export default function match (template, target) {
  let valid = true

  function fn (template, target) {
    if (valid === false) {
      return
    }
    if (typeof template === 'boolean') {
      valid = ![null, undefined].includes(target)
    } else if (({}).toString.call(template) !== ({}).toString.call(target)) {
      valid = false
    } else {
      if (template instanceof Array) {
        if (template.length <= target.length) {
          for (let i = 0; i < template.length; i++) {
            fn(template[i], target[i])
          }
        } else {
          valid = false
        }
      } else if (template instanceof Object) {
        if (Object.getOwnPropertyNames(template).length <= Object.getOwnPropertyNames(target).length) {
          for (let k in template) {
            fn(template[k], target[k])
          }
        } else {
          valid = false
        }
      } else {
        if (template !== target) {
          valid = false
        }
      }
    }
  }

  fn(template, target)

  if (valid === false) {
    //console.log('没有相关数据')
  }

  return valid
}
